import { BrandRepository, CreateBrandInput } from '../../domain/repositories/brand.repository';
import { BrandEntity } from '../../domain/entities/brand.entity';

export class CreateBrandUseCase {
  constructor(private readonly brandRepository: BrandRepository) {}

  async execute(data: CreateBrandInput): Promise<BrandEntity> {
    return this.brandRepository.createBrand(data);
  }
}
